import { BaseProvider } from '@ethersproject/providers'
import { Contract, BigNumber, BigNumberish, ContractTransaction } from 'ethers'
import { Result as ContractResult } from '@ethersproject/abi'
import { Event as ContractEvent } from '@ethersproject/contracts'

import useContract from './useContract'
import { ERC20 } from '../abi'

interface ERC20Contract extends Contract {
  readonly balanceOf: (account: string) => Promise<BigNumber>
  readonly approve: (
    spender: string,
    amount: BigNumberish
  ) => Promise<ContractTransaction>
}

export default function useERC20(
  provider: BaseProvider,
  address: string
): ERC20Contract | null {
  return useContract(provider, address, ERC20) as ERC20Contract | null
}

export namespace ERC20Types {
  export namespace Event {
    interface ApprovalEventResult extends ContractResult {
      owner: string
      spender: string
      value: BigNumber
    }

    export interface ApprovalEvent extends ContractEvent {
      args: ApprovalEventResult
    }
  }
}
